import { createSlice } from "@reduxjs/toolkit";


interface PatientTypes {
    id: string;
    first_name: string;
    middle_name?: string | null;
    photo_url: string;
    last_name: string;
    mobile_number: string;
    gender?: "male" | "female" | "other" | "";
    created_at?: Date|undefined;
    date_of_birth: Date|undefined;
    hippa_consent: boolean;
}

const patient: PatientTypes = {
    id: "",
    first_name: "",
    middle_name: "",
    last_name: "",
    mobile_number: "",
    date_of_birth: undefined,
    photo_url: "",
    gender: "",
    created_at: undefined,
    hippa_consent: false,
};

type InitialStateTypes =  {
    token: string;
    patient: PatientTypes;
    expiresIn: string;
}

const initialState:InitialStateTypes = {
  token: "",
  patient: patient,
  expiresIn: "",
};
const patientSlice = createSlice({
  name: "patient",
  initialState: initialState,
  reducers: {
    setPatient: (state, action) => {
      Object.assign(state, action.payload);
    },
    resetPatient: (state) => {
      state.token = initialState.token
      state.patient = initialState.patient
      state.expiresIn = initialState.expiresIn
    },
  },
});

export const { setPatient, resetPatient } = patientSlice.actions;

export default patientSlice.reducer;
